// Shared dictionary preview card — used by both the public and user
// dictionary lists so their grids never drift apart. Shape matches the
// Play page's .mode-card (centered, an icon above the title, outlined
// per §4.7 — see index.css) instead of the old left-aligned card with
// word-chip previews. Sample words are gone (not useful for picking a
// dictionary); word count and upload date take their place, both from
// real API columns rather than a CSV read (see apis/serializers.py's
// DictionaryListSerializer docstring for why that distinction matters).
// Mirrors the same reformat done on the mobile app's DictionaryCard.js.
function BookIcon() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 24 24"
      fill="none"
      stroke="var(--ww-rose)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  );
}

function formatUploadDate(isoString) {
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

function DictionaryCard({ dict, onClick }) {
  const hasWordCount = typeof dict.word_count === "number" && dict.word_count > 0;
  const uploadDate = dict.created_at ? formatUploadDate(dict.created_at) : null;

  return (
    <button className="dict-card" onClick={onClick}>
      <BookIcon />
      <span className="dict-card__title">{dict.title}</span>
      {dict.description && <span className="dict-card__desc">{dict.description}</span>}
      {(hasWordCount || uploadDate) && (
        <span className="dict-card__meta">
          {hasWordCount ? `${dict.word_count.toLocaleString()} word${dict.word_count === 1 ? "" : "s"}` : null}
          {hasWordCount && uploadDate ? "  ·  " : null}
          {uploadDate ? `Uploaded ${uploadDate}` : null}
        </span>
      )}
    </button>
  );
}

export default DictionaryCard;
